import { Button } from "@mantine/core";
import classes from "./needHelpBanner.module.css";

import useAppTranslation from "@hooks/language/useAppTranslation";
import useTidioChat from "@hooks/useTidioChat";
import { IconMessageCircleFilled } from "@tabler/icons-react";

const ButtonLiveChat: React.FC = () => {
  const { t } = useAppTranslation("common.helpBanner");
  const { open } = useTidioChat();

  return (
    <Button
      className="hover-scale w-full bg-primary-default/50 font-black font-inter text-primary-light-text text-sm backdrop-blur hover:bg-primary-default/70 sm:w-auto"
      classNames={classes}
      fw={"bold"}
      leftSection={<IconMessageCircleFilled height={24} width={24} />}
      radius={8}
      size="lg"
      variant="light"
      onClick={open}
    >
      {t("liveChatButton")}
    </Button>
  );
};

export default ButtonLiveChat;
